import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { TradeInfo } from '../services/token.service';

interface WsTradeListState {
  trades: TradeInfo[];
}

const initialState: WsTradeListState = {
  trades: [],
};

export const wsTradeListSlice = createSlice({
  name: 'wsTradeList',
  initialState,
  reducers: {
    updateWsTradeList: (state, action: PayloadAction<TradeInfo[]>) => {
      state.trades = action.payload;
    },
    clearWsTradeList: (state) => {
      state.trades = [];
    },
  },
});

// 导出 actions
export const { updateWsTradeList, clearWsTradeList } = wsTradeListSlice.actions;

// 导出 selectors
export const selectWsTradeList = (state: RootState) => state.wsTradeList.trades;

export default wsTradeListSlice.reducer;
